import {
  outreachAggregateReportPath,
  outreachAggregateReportHistoryPath,
  visitHistoryReportPath
} from '../../../routes/Paths';

const NAV_KEYS = {
  OUTREACH_AGGREGATE: 'outreach-aggregate',
  GENERATE_REPORT: 'generate-report',
  DOWNLOAD_HISTORY: 'download-history',
  GUEST_REPORT: 'guest-report',
  VISIT_HISTORY: 'visit-history'
};

export const navKeysByPath = {
  [outreachAggregateReportPath]: NAV_KEYS.GENERATE_REPORT,
  [outreachAggregateReportHistoryPath]: NAV_KEYS.DOWNLOAD_HISTORY,
  [visitHistoryReportPath]: NAV_KEYS.VISIT_HISTORY
};

export default NAV_KEYS;
